import React from 'react';
import {
  Button,
  Form, Input, Layout, message, theme, Typography,
} from 'antd';
import axios from 'axios';

const LoginsNew = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = (values) => {
    const csrf = document.head.querySelector("[name='csrf-token']").content;

    axios({
      headers: { 'X-CSRF-Token': csrf },
      method: 'post',
      url: '/login',
      data: values,
    }).then(() => {
      messageApi.success('Успішний вхід, зараз буде перенаправлення...');
      document.location.href = '/tickets';
    }).catch((error) => {
      const errorMessage = error?.response?.data?.error || 'Помилка при вході';
      messageApi.error(errorMessage);
    });
  };

  return (
    <div className="container">
      <Layout
        style={{
          padding: '24px 0',
          marginTop: 15,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        <Layout.Content style={{ padding: '0 48px' }}>
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 24,
              borderRadius: borderRadiusLG,
            }}
          >
            {contextHolder}
            <Typography.Title>Вхід</Typography.Title>

            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label="Пошта"
                name="email"
                rules={[{ required: true, message: 'Будь ласка, введіть пошту' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Пароль"
                name="password"
                rules={[{ required: true, message: 'Будь ласка, введіть пароль' }]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                  Увійти
                </Button>
              </Form.Item>
            </Form>

            <script
              src="https://telegram.org/js/telegram-widget.js?22"
              data-telegram-login="kcas_support_prod_bot"
              data-size="large"
              data-auth-url="https://kcas-support-bot.splace.online/login/telegram_login"
              data-request-access="write"
              async
            />
          </div>
        </Layout.Content>
      </Layout>
    </div>
  );
};

export default LoginsNew;
